import { MapStringTo } from "../base-types";
import { IEntity } from "../contracts/base/entity";
import { IRelatedPath, IRelatedPathItem } from "../contracts/base/related-path";
import { EntityResource } from "../models/entity-resource";

export class RelatedPathMapper {
    mapRelatedPaths(resource: EntityResource): Array<IRelatedPath> {
        if (resource == null || resource.relatedPaths == null || Object.keys(resource.relatedPaths).length === 0) {
            return [];
        }

        const relatedPaths = resource.relatedPaths as MapStringTo<Array<Array<IRelatedPathItem>>>;

        const list: Array<IRelatedPath> = [];

        for (const relatedPathName in relatedPaths) {
            const values = relatedPaths[relatedPathName];
            if (!values || values.length === 0) {
                continue;
            }

            const relatedPath: IRelatedPath = {
                name: relatedPathName,
                items: values.map(items =>
                    items.map(item => ({
                        values: item.values,
                        definition: item.definition,
                        entity: item.entity,
                        properties: item.properties || null,
                    }))
                ),
            };

            list.push(relatedPath);
        }

        return list;
    }

    mapToResource(entity: IEntity): MapStringTo<unknown> | undefined {
        if (entity == null || entity.relatedPaths == null || Object.keys(entity.relatedPaths).length === 0) {
            return undefined;
        }

        const list: MapStringTo<unknown> = {};

        for (const relatedPath of entity.relatedPaths) {
            list[relatedPath.name] = relatedPath.items;
        }

        return list;
    }
}
